import { gql } from "@apollo/client";

const DELETE_CLIENT = gql`
    mutation deleteClient($id: ID!) {
        deleteClient(id: $id) {
            id
            name
            email
            phone
        }
    }
`

const ADD_CLIENT = gql`
    mutation addClient($name: NonEmptyString!, $email: NonEmptyString!, $phone:NonEmptyString!) {
        addClient(name: $name, email: $email, phone: $phone) {
            id
            name
            email
            phone
        }
    }
`



export { DELETE_CLIENT, ADD_CLIENT }